import { DEV } from 'cc/env';
import { _decorator, Label, Font, CCFloat, Color, HorizontalTextAlignment, Enum, VerticalTextAlignment, Overflow } from 'cc';
import OrientedComponent, { OrientedBaseProperty } from './OrientedComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('OrientedLabelProperties')
class OrientedLabelProperties extends OrientedBaseProperty {
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整Label字型' })
    public updateFont: boolean = false;
    @property({
        type: Font,
        tooltip: DEV && '字型資源',
        visible(this: OrientedLabelProperties) {
            return this.updateFont;
        },
    })
    public font: Font = null;
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整Label字體大小' })
    public updateFontSize: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '字體大小',
        visible(this: OrientedLabelProperties) {
            return this.updateFontSize;
        },
    })
    public fontSize: number = 14;
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整Label行距' })
    public updateLineHeight: boolean = false;
    @property({
        type: CCFloat,
        tooltip: DEV && '行距',
        visible(this: OrientedLabelProperties) {
            return this.updateLineHeight;
        },
    })
    public lineHeight: number = 14;
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整Label顏色' })
    public updateColor: boolean = false;
    @property({
        tooltip: DEV && 'Label顏色',
        visible(this: OrientedLabelProperties) {
            return this.updateColor;
        },
    })
    public color: Color = new Color();
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整 Label Spacing' })
    public updateSpacing: boolean = false;
    @property({
        tooltip: DEV && 'Label Spacing',
        visible(this: OrientedLabelProperties) {
            return this.updateSpacing;
        },
    })
    public spacing: number = 0;
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整文字水平對齊方式，節點上必需有 Label 組件才會生效' })
    public updateHorizontalTextAlign: boolean = false;
    @property({
        type: Enum(HorizontalTextAlignment),
        tooltip: DEV && '文字水平對齊方式',
        visible(this: OrientedLabelProperties) {
            return this.updateHorizontalTextAlign;
        },
    })
    public horizontalTextAlign: HorizontalTextAlignment = HorizontalTextAlignment.CENTER;
    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整文字垂直對齊方式，節點上必需有 Label 組件才會生效' })
    public updateVerticalTextAlign: boolean = false;
    @property({
        type: Enum(VerticalTextAlignment),
        tooltip: DEV && '文字垂直對齊方式',
        visible(this: OrientedLabelProperties) {
            return this.updateVerticalTextAlign;
        },
    })
    public verticalTextAlign: VerticalTextAlignment = VerticalTextAlignment.CENTER;

    @property({ tooltip: DEV && '旋轉為該方向時，是否該依據設定調整文字排版方式' })
    public updateOverflow: boolean = false;
    @property({
        type: Enum(Overflow),
        tooltip: DEV && '文字排版方式',
        visible(this: OrientedLabelProperties) {
            return this.updateOverflow;
        },
    })
    public overflow: Overflow = Overflow.NONE;
}

@ccclass('OrientedLabel')
@requireComponent(Label)
@menu('Orientation/OrientedLabel')
export default class OrientedLabel extends OrientedComponent<Label> {
    @property({ type: OrientedLabelProperties, group: '橫式' })
    public readonly landscapeProperties: OrientedLabelProperties = null;
    @property({ type: OrientedLabelProperties, group: '直式' })
    public readonly portraitProperties: OrientedLabelProperties = null;

    protected updateOrientationProperties(properties: OrientedLabelProperties) {
        if (properties.updateFont) {
            this.target.font = properties.font;
        }
        if (properties.updateFontSize) {
            this.target.fontSize = properties.fontSize;
        }
        if (properties.updateLineHeight) {
            this.target.lineHeight = properties.lineHeight;
        }
        if (properties.updateSpacing) {
            this.target.spacingX = properties.spacing;
        }
        if (properties.updateColor) {
            this.target.color = properties.color;
        }
        if (properties.updateHorizontalTextAlign) {
            this.target.horizontalAlign = properties.horizontalTextAlign;
        }
        if (properties.updateVerticalTextAlign) {
            this.target.verticalAlign = properties.verticalTextAlign;
        }
        if (properties.updateOverflow) {
            this.target.overflow = properties.overflow;
        }
    }

    protected getTarget() {
        return this.getComponent(Label);
    }
}
